import React from 'react';
import { MLOutcome } from '../../data/industryData';
import '../../styles/MLOutcomes.css';

interface MLOutcomesProps {
  outcomes: MLOutcome[];
}

const MLOutcomes: React.FC<MLOutcomesProps> = ({ outcomes }) => {
  return (
    <div className="ml-outcomes-section">
      <div className="ml-outcomes-container">
        <h2 className="ml-outcomes-title">Real-World ML/AI Project Outcomes</h2>
        <p className="ml-outcomes-subtitle">
          We've delivered tangible results for AI-first companies facing complex infrastructure challenges
        </p>
        
        <div className="ml-outcomes-grid">
          {outcomes.map((outcome, index) => (
            <div className="value-card">
            <span className="industry-card-number-idc">{String(index + 1).padStart(2, '0')}</span>
              {/* <span className="value-number">01</span> */}
              <h2 className="value-title">{outcome.title}</h2>

              <div className="ml-outcome-content">
                 <div className="ml-outcome-row">
                   <h4 className='ml-outcome-content-title'>Challenge:</h4>
                   <p className="value-description">{outcome.challenge}</p>
                 </div>
                
                 <div className="ml-outcome-row">
                   <h4 className='ml-outcome-content-title'>Solution:</h4>
                   <p className="value-description">{outcome.solution}</p>
                 </div>
                
                 <div className="ml-outcome-row">
                   <h4 className='ml-outcome-content-title'>Impact:</h4>
                 <p className="value-description">{outcome.impact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MLOutcomes; 